import React from 'react';
import styles from '../irlObservations2026.module.css';
import { ModalShell } from '../chrome';

export default function IRL_AI_Review_Review_Response_5({ onReview, onClose, counts }) {
    const proposedResponses = counts?.proposed_responses ?? 0;
    const proposedObservations = counts?.proposed_observations ?? 0;
    const followUps = counts?.follow_ups ?? 0;
    const contradictions = counts?.contradictions ?? 0;
    return (
        <ModalShell width="narrow">
            <div className={styles.modalHead}>
                <h2 className={styles.modalTitle}>AI Review complete</h2>
                <button type="button" className={styles.modalClose} onClick={onClose} aria-label="Close">
                    ×
                </button>
            </div>
            <div className={styles.modalBody}>
                <div className={styles.statGrid}>
                    <div className={styles.statCard}>
                        <p className={styles.statNum}>{proposedResponses}</p>
                        <p className={styles.statLabel}>Proposed responses</p>
                    </div>
                    <div className={styles.statCard}>
                        <p className={styles.statNum}>{proposedObservations}</p>
                        <p className={styles.statLabel}>Proposed observations</p>
                    </div>
                    <div className={styles.statCard}>
                        <p className={styles.statNum}>{followUps}</p>
                        <p className={styles.statLabel}>Follow-up requests</p>
                    </div>
                    <div className={styles.statCard}>
                        <p className={styles.statNum}>{contradictions}</p>
                        <p className={styles.statLabel}>Contradictions</p>
                    </div>
                </div>
            </div>
            <div className={styles.modalFoot}>
                <button type="button" className={styles.primaryBtn} onClick={onReview}>
                    Review suggestions
                </button>
                <button type="button" className={styles.mutedBtn} onClick={onClose}>
                    Close
                </button>
            </div>
        </ModalShell>
    );
}
